import { render, staticRenderFns } from "./ReportDeta.vue?vue&type=template&id=5d92cc66&scoped=true&"
import script from "./ReportDeta.vue?vue&type=script&lang=js&"
export * from "./ReportDeta.vue?vue&type=script&lang=js&"
import style0 from "./ReportDeta.vue?vue&type=style&index=0&id=5d92cc66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92cc66",
  null
  
)

export default component.exports